import React from 'react'
import type { FormProps } from 'react-final-form'
import { Form } from 'react-final-form'
import { injectMessages } from '@/logic/translation/utils'
import { SearchInput } from '../..'
import type { ISearchFormProps } from './interfaces'
import messages from './messages.json'

injectMessages(messages)

const SearchForm: React.FC<ISearchFormProps & Partial<FormProps>> = props => {
  const { className, fieldId, fieldName, onSubmit, inputProps, searchInputProps } = props

  const content = (
    <SearchInput
      className={className}
      textInputProps={{
        name: fieldName,
        modifiers: ['white'],
        placeholderId: `searchForm.placeholder.${fieldId}Field.text`,
        ...inputProps,
      }}
      {...searchInputProps}
    />
  )

  if (!onSubmit) return content

  return <Form onSubmit={onSubmit}>{() => content}</Form>
}

export default SearchForm
